import '@getvim/atomic-ui/assets/styles/main.less';
import { ThemeVariablesWrapper, themes } from '@getvim/components-hooks-use-theme';
import { VimSDKProvider } from '@getvim/internal-vim-os-sdk/react';
import { TelemetryProvider } from '@getvim/opentelemetry-sdk/react';
import { ErrorBoundaryWrapper } from '@getvim/atomic-ui';
import 'bootstrap/less/bootstrap.less';
import React, { useCallback } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import AppWrapper from './components/AppWrapper';
import ConfigurationComponent from './components/configuration';
import { RequiredStateWrapper } from './components/RequiredStateWrapper';
import './index.less';
import { GlobalStateProvider } from './stores/GlobalStore';
import { APP_ID, AppEnv } from './types';
import sdkOptions from './sdkOptions';
import { createLogger } from './utils/logger';
import { FeatureFlagProvider, ffClientOptions } from './utils/featureFlags';

const appEnv: AppEnv = (window as any).$vim_environment?.APP_ENV;

const logger = createLogger('OU error handler');

const AppSdkWrapper = () => {
  const handleRenderError = useCallback(({ error }) => {
    logger.error('Client application crashed due to render error', {
      error: error.message,
      noPHI: true,
    });
    logger.error('Client application crashed due to render error', {
      error,
    });
  }, []);
  return (
    <ErrorBoundaryWrapper
      applicationDisplayName="Optum Order Utility"
      onRenderError={handleRenderError}
    >
      <TelemetryProvider
        options={{
          serviceName: APP_ID,
          env: appEnv,
          enableLogs: appEnv === AppEnv.DEV,
          enableMetrics: appEnv === AppEnv.DEV,
          enableTraces: appEnv === AppEnv.DEV,
        }}
      >
        <VimSDKProvider {...sdkOptions}>
          <ThemeVariablesWrapper theme={themes.optum}>
            <GlobalStateProvider>
              <RequiredStateWrapper>
                <FeatureFlagProvider {...ffClientOptions}>
                  <AppWrapper />
                </FeatureFlagProvider>
              </RequiredStateWrapper>
            </GlobalStateProvider>
          </ThemeVariablesWrapper>
        </VimSDKProvider>
      </TelemetryProvider>
    </ErrorBoundaryWrapper>
  );
};

const ConfigurationComponentWrapper = () => {
  return (
    <FeatureFlagProvider {...ffClientOptions}>
      <ConfigurationComponent />
    </FeatureFlagProvider>
  );
};

const router = createBrowserRouter([
  {
    element: <AppSdkWrapper />,
    index: true,
  },
  {
    element: <ConfigurationComponentWrapper />,
    path: '/console-ui',
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<RouterProvider router={router} />);
